import {
  Box,
  Button,
  IconButton,
  TextField,
  ThemeProvider,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import theme from "../../theme";
import { Container } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import sfLogo from "../../assets/icons/logologin.png";
import useForgotPassword from "../../hooks/useForgotPassword";
import SendEmailPopup from "./components/SendEmailPopup";
import { useTranslate } from "ra-core";
const useStyles = makeStyles((theme) => ({
  allContainer: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.lightGray2,
    borderColor: "transparent",
    display: "grid",
    placeItems: "center",
  },
  sfLogo: {
    width: 200,
    height: 86,
    marginTop: 55,
  },
  resetPasswordButton: {
    marginTop: 10,
    boxSizing: "border-box",
    width: 352,
    height: 49,
    fontSize: 18,
  },
  cancelButton: { fontSize: 18, marginTop: 10, color: theme.darkGray },
  backIcon: { margin: "30px 30px 0 30px" },
  alignCenterContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },

  forgotPasswordText: {
    fontSize: 18,
    fontWeight: 600,
    color: theme.orange,
    marginTop: 40,
    width: 352,
    boxSizing: "border-box",
  },
  textUnderForgotPasswordText: {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 14,
    color: theme.darkGray,
    width: 352,
    boxSizing: "border-box",
  },
  helperText: {
    margin: 0,
    padding: 0,
    textAlign: "right",
    fontSize: 10,
    color: theme.red,
  },
  paper: {
    backgroundColor: "white",
    borderRadius: 8,
    width: 458,
    height: 585,
  },
}));
function ForgotPassword() {
  const translate = useTranslate();
  const [username, setUsername] = useState("");
  const [errorTextField, setErrorTextField] = useState(false);
  const [maskedEmail, setMaskedEmail] = useState();
  const [refCode, setRefCode] = useState();
  const history = useHistory();
  const classes = useStyles();
  const { forgotPassword } = useForgotPassword();

  const [openDialog, setOpenDialog] = useState(false);
  const handleClickOpen = () => {
    setOpenDialog(true);
  };
  const handleClose = () => {
    setOpenDialog(false);
  };
  return (
    <ThemeProvider theme={theme}>
      <Box className={classes.allContainer}>
        <Box className={classes.alignCenterContainer}>
          <Box className={classes.paper}>
            <IconButton
              classes={{ root: classes.backIcon }}
              onClick={() => history.goBack()}
            >
              <ArrowBackIosIcon />
            </IconButton>

            <Container
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img src={sfLogo} alt="sflogo" className={classes.sfLogo} />

              <Typography className={classes.forgotPasswordText} align="left">
                {translate("ra.text.forgotPassword.forgotPassword")}
              </Typography>

              <Typography
                className={classes.textUnderForgotPasswordText}
                align="left"
              >
                {translate("ra.text.forgotPassword.enterUsernameBelow")}
              </Typography>

              <TextField
                id="standard-basic"
                placeholder="Username"
                error={errorTextField}
                helperText={
                  errorTextField
                    ? translate("ra.text.forgotPassword.usernameError")
                    : ""
                }
                FormHelperTextProps={{ className: classes.helperText }}
                style={{
                  marginTop: 10,
                  boxSizing: "border-box",
                  width: 352,
                }}
                variant="outlined"
                onChange={(e) => setUsername(e.target.value)}
              />
              <br />

              <Button
                variant="contained"
                color="primary"
                disabled={username.length > 0 ? false : true}
                className={classes.resetPasswordButton}
                onClick={async () => {
                  const [result, error] = await forgotPassword(username);
                  if (error) {
                    setErrorTextField(true);
                  }
                  if (result) {
                    setErrorTextField(false);
                    setMaskedEmail(result.payload.target);
                    setRefCode(result.payload.ref_code);
                    handleClickOpen(true);
                  }
                }}
              >
                {translate("ra.text.forgotPassword.resetPassword")}
              </Button>
              <Button
                onClick={() => history.goBack()}
                className={classes.cancelButton}
              >
                {translate("ra.action.cancel")}
              </Button>
            </Container>
          </Box>
        </Box>
      </Box>
      <SendEmailPopup
        open={openDialog}
        onClose={handleClose}
        username={username}
        maskedEmail={maskedEmail}
        refCode={refCode}
      />
    </ThemeProvider>
  );
}

export default ForgotPassword;
